import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { __asyncI18n, __i18n } from '@localisation';
import { ErrorExtractorService } from '@tools';
import { MessagesService, MessageType } from '@ui-messages';
import { ThirdPartyAppsService } from './third-party-apps.service';


@Component({
    selector: 'third-party-app-register',
    templateUrl: './third-party-app.register.template.html',
    standalone: false
})
export class ThirdPartyAppRegisterComponent {
    constructor(
        private service: ThirdPartyAppsService,
        private messages: MessagesService,
        private extractor: ErrorExtractorService,
        private router: Router
    ){}

    public validationMessage: string = __i18n('This is not a valid app id!', 'third-party-app.register.validatio.error.app-id');

    public async register(appId: string){
        try{
            await this.service.registerThirdPartyApp(appId);
            this.messages.addMessage({
                type: MessageType.success,
                location: '/Administration/ThirdPartyApps',
                text: __i18n('App successfully registered!', 'third-party-app.register.success.message')
            });

            this.router.navigateByUrl('/Administration/ThirdPartyApps');
        }catch(e){
            let errorMessage;
            if(typeof e.error === 'string'){
                e.error = JSON.parse(e.error);
            }
            if(e?.error?.error?.errorCode === 0){
                errorMessage = __i18n('The request is invalid: The data field is invalid, The name is required.', 'third-party-app.register.invalid-request.error.message');
            }else{
                errorMessage = this.extractor.extractErrorMessage(e);
            }
            this.messages.addMessage({
                type: MessageType.error,
                text: errorMessage
            })
        }
    }
}